import React from 'react';
import Spinner from 'react-spinner';

import fetchContent from '../../helpers/backend-communication';

import NationalReportsListCount from './NationalReportsListCount';
import NationalReportsListItem from './NationalReportsListItem';

import { getCountryName } from '../../helpers/countryNames';

class NationalReportsList extends React.Component {
  constructor(props) {
    super(props);

    this.requestReports = this.requestReports.bind(this);
    this.mostRecentQueryString = null;

    this.state = {
      reports: null,
      isLoading: false,
    };
  }

  componentWillUpdate(nextProps) {
    if (nextProps !== this.props) this.requestReports(nextProps);
  }

  componentDidMount() {
    this.requestReports(this.props);
  }

  requestReports(options) {
    const { country, group, year } = options;
    const queryStringArray = [];

    this.setState({
      isLoading: true,
      reports: [],
    });

    if (country && country.length > 0) {
      queryStringArray.push(`country__iso_alpha_3=${country}`);
    }

    if (group && group.length > 0 && group !== 'GLOBAL') {
      queryStringArray.push(`country__region_set__regional_group=${group}`);
    }

    if (year) {
      queryStringArray.push(`reporting_year=${year}`);
    }

    const queryString = (queryStringArray.length > 0)
      ? `?${queryStringArray.join('&')}`
      : '';

    if (queryString !== this.mostRecentQueryString) {
      this.mostRecentQueryString = queryString;

      fetchContent('reports', queryString)
        .then(responseObject => this.onRequestComplete(responseObject.data, queryString))
        .catch(error => {
          console.error('Fetch went wrong', error);
        })
        .then(() => this.setState({ isLoading: false }));
    }
  }

  onRequestComplete(reports, queryString) {
    if (this.mostRecentQueryString !== queryString || !Array.isArray(reports)) return null;

    reports = this.fillCountryNames(reports);
    reports = this.orderReports(reports);
    reports = this.joinMultiLanguageReports(reports);

    this.setState({ reports });
  }

  joinMultiLanguageReports(reports) {
    const joinedReports = [];

    reports.forEach(item => {
      const lastReport = joinedReports[joinedReports.length - 1];
      const reportLink = {
        language: item.attributes.language,
        link: item.links.reportFile
      };

      if (
        lastReport &&
        lastReport.attributes.countryName === item.attributes.countryName &&
        lastReport.attributes.reportingYear === item.attributes.reportingYear
      ) {
        lastReport.reportLinks.push(reportLink);
      } else {
        item.reportLinks = [reportLink];
        joinedReports.push(item);
      }
    });

    return joinedReports;
  }

  fillCountryNames(reports) {
    reports = reports.map(item => {
      item.attributes.countryName = getCountryName(item.attributes.country) || "";
      return item;
    });

    return reports;
  }

  orderReports(reports) {
    reports.sort(function (itemA, itemB) {
      let position = itemB.attributes.reportingYear - itemA.attributes.reportingYear;

      if (position === 0) {
        let countryA = itemA.attributes.countryName.toLowerCase();
        let countryB = itemB.attributes.countryName.toLowerCase();

        if (countryA === countryB) {
          let languageA = itemA.attributes.language;
          let languageB = itemB.attributes.language;

          if (languageA < languageB) {
            position = -1;
          } else if (languageA > languageB) {
            position = 1;
          } else {
            position = 0;
          }
        } else if (countryA < countryB) {
          position = -1;
        } else if (countryA > countryB) {
          position = 1;
        }
      }

      return position;
    });

    return reports;
  }

  renderListItems() {
    const reports = this.state.reports;

    if (!reports || reports.length === 0) return null;

    return reports.map((item, index) => (
      <NationalReportsListItem key={ index } data={ item } />
    ));
  }

  render() {
    return (
      <div className="reports-search-results">
        { this.state.isLoading ? (
          <div className="reports-search-results__loading">
            <Spinner />
          </div>
        ) : (
          <div>
            <NationalReportsListCount list={ this.state.reports }/>
            <table width="418" className="table table-responsive reports-table">
              <tbody>
                <tr>
                  <th>Reporting year</th>
                  <th>Country</th>
                  <th>Available in</th>
                </tr>

                { this.renderListItems() }
              </tbody>
            </table>
          </div>
        ) }
      </div>
    );
  }
}

export default NationalReportsList;



// WEBPACK FOOTER //
// ./src/components/NationalReports/NationalReportsList.js